// Must be first import
import process from 'process';
import { Buffer } from 'buffer';

window.process = process;
window.Buffer = Buffer;

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import './index.css';
import App from './app';
import registerServiceWorker, {unregister} from './registerServiceWorker';

import ScrollToTop from './components/core/scroll-to-top/scroll-to-top';


ReactDOM.render((
  <BrowserRouter>
    <ScrollToTop>
      <App />
    </ScrollToTop>
  </BrowserRouter>
), document.getElementById('root'));

// registerServiceWorker();
unregister();
